// @ts-nocheck FIXME
import React from 'react';
import ScaleCenterImage from './../../ScaleCenterImage';

class StrategyImage extends React.Component {
  state = {
    viablePreview: false,
  };

  // after a component mounts, link the sorting functionality
  componentDidMount() {
    const thisComponent = this;
    // don't attempt to check preview when no imgSrc supplied
    if (!this.props.preview) {
      return;
    }

    // create image instance
    const image = new Image();
    image.src = this.props.preview;

    // check if loads: return true
    image.onload = function () {
      thisComponent.setState({
        viablePreview: true,
      });
    };
  }

  // render the component that is passed in
  render() {
    if (!this.state.viablePreview) {
      return (
        <div className={this.props.containerClass}>
          <div
            className={
              this.props.imageClass +
              '-mask ' +
              this.props.imageClass +
              '--none'
            }
          >
            <div
              className={
                'strategy__preview-icon file-type-icon ext-' + this.props.icon
              }
            ></div>
          </div>
        </div>
      );
    }

    return (
      <div className={this.props.containerClass}>
        <ScaleCenterImage
          src={this.props.preview}
          className={this.props.imageClass}
          alt={this.props.title}
          icon={this.props.icon}
        />
      </div>
    );
  }
}

export default StrategyImage;
